module.exports = __webpack_public_path__ + "static/img/AIGC设计-产品场景图.b3b6fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC设计-产品场景图.png
// module id = /Kk4
// module chunks = 1